module.exports = __webpack_public_path__ + "static/updated-9c7cb70a86c44152c249d79a3d4713f7.png";